import { useTranslation } from "react-i18next";
import { LegalLayout } from "./legal-layout";

export function PrivacyPage() {
  const { t } = useTranslation("legal");
  const sections = t("privacy.sections", { returnObjects: true }) as Array<{
    heading: string;
    content: string;
  }>;
  return (
    <LegalLayout
      title={t("privacy.title")}
      lastUpdated={t("privacy.lastUpdated")}
      sections={sections}
    />
  );
}
